import React from "react"
import ReactDOM from "react-dom/client"
import "@fontsource/roboto/400.css"
import "@fontsource/roboto/500.css"
import "@fontsource/roboto/600.css"
import "@fontsource/roboto-condensed/700.css"
import App from "./App"
import "./pages/FigmaThemeTokens.css"
import "./index.css"
import "./pages/TelegramViewport.css"
import "./pages/TopNoticeOverrides.css"
import "./pages/ScrollFadeOverdraw.css"
import "./pages/LocalizationLayoutOverrides.css"

type NavigatorWithVirtualKeyboard = Navigator & {
  virtualKeyboard?: {
    overlaysContent: boolean
  }
}

const initialTelegramScheme = window.Telegram?.WebApp?.colorScheme
if (initialTelegramScheme === "light" || initialTelegramScheme === "dark") {
  document.documentElement.dataset.tgColorScheme = initialTelegramScheme
  document.documentElement.style.colorScheme = initialTelegramScheme
}

const virtualKeyboard = (navigator as NavigatorWithVirtualKeyboard).virtualKeyboard
if (virtualKeyboard) {
  try {
    virtualKeyboard.overlaysContent = true
  } catch {
    // Unsupported/blocked WebViews fall back to Telegram stable-height locking.
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
